import { render, staticRenderFns } from "./SpecieDetails.vue?vue&type=template&id=f1b12ee8&scoped=true"
import script from "./SpecieDetails.vue?vue&type=script&lang=js"
export * from "./SpecieDetails.vue?vue&type=script&lang=js"
import style0 from "./SpecieDetails.vue?vue&type=style&index=0&id=f1b12ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b12ee8",
  null
  
)

export default component.exports